import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faYoutube, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";




export class Footer extends Component {
  render() {
    return (
      <Fragment>
        <div className="footer-wrapper">
          <footer className="custom-footer">
            <div className="footer-container">
              {/* Newsletter */}
              <div className="form-container">
                <div className="form-box">
                  <form className="custom-contact-form" onSubmit={(e) => e.preventDefault()}>
                    <h4 className="footer-heading">SUBSCRIBE TO OUR NEWSLETTER</h4>

                    <div className="custom-form-group">
                      <label htmlFor="footer-email" className="sr-only">Email</label>
                      <input
                        type="email"
                        id="footer-email"
                        name="email"
                        placeholder="Enter your email"
                        required
                      />
                    </div>

                    <div className="button-container">
                      <button type="submit" className="custom-submit-btn">Subscribe</button>
                    </div>
                  </form>
                </div>
              </div>

              {/* Quick Links */}
              <div className="footer-quick-links">
                <h4 className="footer-heading">QUICK LINKS</h4>
                <ul className="footer-links-list">
                  <li><a href="/">Home</a></li>
                  <li><a href="https://shop.connect767.com/" target="_blank" rel="noopener noreferrer">Shop</a></li>
                  <li><a href="#about">About Us</a></li>
                  <li><a href="#faqs">FAQs</a></li>
                </ul>
              </div>

              {/* Services */}
              <div className="footer-services">
                <h4 className="footer-heading">OUR SERVICES</h4>
                <ul className="footer-links-list">
                  <li><a href="#professional-networking">Professional Networking</a></li>
                  <li><a href="#consulting-services">Consulting Services</a></li>
                  <li><a href="#manufacturing-services">Manufacturing Services</a></li>
                  <li><a href="#partnership-programs">Partnership Programs</a></li>
                </ul>
              </div>

              {/* Contact + Social */}
             <div className="footer-info">
  <h4 className="footer-heading">CONTACT US</h4>

  <ul className="footer-info-list">
    <li>
      <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: 8 }} />
      <a href="mailto:info@connect767.com">info@connect767.com</a>
    </li>
    <li>
      <FontAwesomeIcon icon={faPhone} style={{ marginRight: 8 }} />
      <a href="tel:8622532076">862-253-2076</a>
    </li>
  </ul>

  <div className="footer-social-media-icons">
    <a
      href="https://www.facebook.com/connect767"
      target="_blank"
      rel="noopener noreferrer"
      className="social-icon"
      aria-label="Facebook"
    >
      <FontAwesomeIcon icon={faFacebookF} style={{ color: "white" }} />
    </a>

    <a
      href="https://www.youtube.com/@connect7678"
      target="_blank"
      rel="noopener noreferrer"
      className="social-icon"
      aria-label="YouTube"
    >
      <FontAwesomeIcon icon={faYoutube} style={{ color: "white" }}/>
    </a>

    <a
      href="https://www.instagram.com/connect767llc/"
      target="_blank"
      rel="noopener noreferrer"
      className="social-icon"
      aria-label="Instagram"
    >
      <FontAwesomeIcon icon={faInstagram} style={{ color: "white" }} />
    </a>
  </div>
</div>

            </div>
          </footer>
        </div>

        <div className="footer-copyright">
          <p>&copy; 2025 NY Creative Studio All Rights Reserved</p>
        </div>
      </Fragment>
    );
  }
}

export default Footer;
